import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { loginSuccess } from '../../actions/authActions';
import { useAuth } from '../../context/AuthContext';


const AuthInitializer = () => {
  const dispatch = useDispatch();
  const { dispatch: authDispatch, actions } = useAuth();
  const isAuthenticated = useSelector(state => state.auth?.isAuthenticated);
  const user = useSelector(state => state.auth?.user);

  useEffect(() => {
    if (!isAuthenticated || !user) {
      const pupilData = localStorage.getItem('pupil');

      if (pupilData) {
        try {
          const pupilObj = JSON.parse(pupilData);
          
          if (pupilObj) {
            const provider = pupilObj.provider || 'email';
            
            dispatch(loginSuccess({
              user: pupilObj,
              provider: provider
            }));
            
            authDispatch({
              type: actions.LOGIN_SUCCESS,
              payload: {
                user: pupilObj,
                provider: provider
              }
            });
          }
        } catch (error) {
          console.error('Failed to restore auth on init:', error);
        }
      }
    }
  }, [dispatch, authDispatch, actions, isAuthenticated, user]);

  return null;
};

export default AuthInitializer;
